import { FormJsx } from 'src/components/form-jsx';

export default FormJsx;
